import React from "react";
import { useCart, useCustomer } from "hooks/useStore";
import { trackAddToCart, trackRemoveFromCart } from "analytics";
import Loader from "components/loader";
import useToggle from "hooks/useToggle";

const QuantityInput = ({ product }) => {
	const { updateCartItem, isUpdating } = useCart(["updateCartItem", "isUpdating"]);
	const customer = useCustomer();
	const [isLoading, toggleLoading] = useToggle();

	const updateQuantity = async (inc = false) => {
		toggleLoading();
		const newQuantity = inc ? product.quantity + 1 : product.quantity - 1;

		await updateCartItem(product.tempId, newQuantity);
		if (inc)
			trackAddToCart({ ...product, quantity: 1 }, customer);
		else
			trackRemoveFromCart({ ...product, quantity: 1 }, customer);

		toggleLoading();
	};

	return (
		<div className="cart-item-qty-input">
			<button disabled={isUpdating} className="bg-cream text-xl" onClick={() => updateQuantity()}>
				-
			</button>
			<span className="min-w-14 text-center">
				{isLoading ? <Loader /> : product.quantity}
			</span>
			<button disabled={isUpdating} className="bg-cream text-xl" onClick={() => updateQuantity(true)}>
				+
			</button>
		</div>
	);
};

export default QuantityInput;